import { render, staticRenderFns } from "./CreateLink.vue?vue&type=template&id=c6e4ce02&scoped=true&"
import script from "./CreateLink.vue?vue&type=script&lang=ts&"
export * from "./CreateLink.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLink.vue?vue&type=style&index=0&id=c6e4ce02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e4ce02",
  null
  
)

export default component.exports